<script setup lang="ts">
import IconHeart from '~icons/mdi/heart-outline'
import IconCart from '~icons/mdi/cart-outline'

const localePath = useLocalePath()
const userStore = useUserStore()
const display = useDisplay()
const cartStore = useCart()
</script>

<template>
  <v-sheet v-if="display.width.value === 0" class="layout-header" />

  <v-app-bar
    flat
    class="layout-header"
    :height="display.width.value !== 0 && display.mdAndUp.value ? '80' : '120'"
  >
    <v-container class="container-fluid-mobile">
      <v-row no-gutters align="center">
        <v-col
          cols="6"
          sm="6"
          md="3"
          lg="3"
          class="pt-3 pt-md-0"
        >
          <LayoutHeaderLogo />
        </v-col>

        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="6"
          order="12"
          order-sm="12"
          order-md="2"
          test-id="search-wrapper"
          class="d-flex justify-center align-center pt-3 pb-2 py-sm-1"
        >
          <LayoutHeaderSearch v-if="userStore.isAuthenticated" />
        </v-col>

        <v-col
          v-if="userStore.isAuthenticated"
          cols="6"
          sm="6"
          md="3"
          lg="3"
          xl="3"
          order="6"
          order-sm="6"
          order-md="10"
          class="d-flex justify-end pt-3 pt-md-0"
        >
          <div class="d-flex align-center justify-end w-100">
            <div
              v-if="userStore.data"
              class="mr-xl-1 flex-grow-1 flex-shrink-1 header-account-wrap"
            >
              <LayoutHeaderAccountMenu />
            </div>

            <v-btn
              v-if="display.mdAndUp.value"
              color="red-600"
              variant="text"
              :to="localePath('/product-favorites')"
              class="text-none px-1 px-xl-2 flex-shrink-0"
              :class="{ 'mr-2': display.xlAndUp.value }"
              :min-width="display.xlAndUp.value ? undefined : 40"
              :aria-label="$t('favorites')"
              data-nav-id="header_favorites"
            >
              <v-icon
                :icon="IconHeart"
                size="large"
                :class="{ 'mr-1': display.xlAndUp.value }"
              />
              <span
                v-if="display.xlAndUp.value"
                class="text-body-1 font-weight-bold"
              >{{ $t('favorites') }}</span>
            </v-btn>

            <v-btn
              v-if="display.mdAndUp.value"
              color="red-600"
              variant="text"
              :to="localePath('/cart')"
              class="text-none px-1 px-xl-2 flex-shrink-0"
              :min-width="display.xlAndUp.value ? undefined : 40"
              :aria-label="$t('cart.title')"
              data-nav-id="header_cart"
            >
              <v-badge
                v-if="cartStore.totalAmount"
                :max="99"
                :content="cartStore.totalAmount"
                color="black"
                floating
                :offset-x="5"
                :offset-y="5"
                :class="{ 'me-1': display.xlAndUp.value }"
              >
                <v-icon :icon="IconCart" size="x-large" />
              </v-badge>
              <v-icon
                v-else
                :icon="IconCart"
                size="x-large"
              />
              <span
                v-if="display.xlAndUp.value"
                class="text-body-1 font-weight-bold ml-2"
              >{{ $t('cart.title') }}</span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<style lang="scss">
.layout-header {
  height: 80px !important;
  background: linear-gradient(90deg, #fbc8db, #fdeef6 30%, #fbc8db) !important;

  > div {
    height: 80px !important;
    background: transparent !important;
  }

  @media (max-width: 960px) {
    height: 120px !important;
    > div {
      height: 120px !important;
    }
  }

  &__search-wrapper {
    width: 720px;
  }
}

.header-account-wrap {
  min-width: 0;
  max-width: 100%;
  display: flex;
  justify-content: flex-end;

  > * {
    min-width: 0;
    max-width: 100%;
  }
}

.container-fluid-mobile {
  @media (max-width: 1280px) {
    max-width: 100%;
  }
}
</style>
